site.headSearch = {
	init: function () {
		$('#searchToggle').on('click', function (e) {
			e.preventDefault();
			$('body').toggleClass('search-open');

			if ($('body').hasClass('search-open')) {
				$('i', '#searchToggle').removeClass('fa-search').addClass('fa-close');
				$('#q').focus();
			}
			else {
				$('i', '#searchToggle').removeClass('fa-close').addClass('fa-search');
			}
		});
	}
};

site.inits.push('site.headSearch.init()');